<template>
  <svg class="chat-composer-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <template v-if="name === 'image'">
      <rect x="3.25" y="4.25" width="17.5" height="15.5" rx="3" />
      <circle cx="8.3" cy="9.1" r="1.55" />
      <path d="m5.7 17 4.1-4.1 2.8 2.65 2.35-2.35 3.35 3.8" />
    </template>
    <template v-else-if="name === 'voice'">
      <rect x="8.2" y="3.25" width="7.6" height="12.3" rx="3.8" />
      <path d="M5.75 11.7a6.25 6.25 0 0 0 12.5 0M12 18v3M8.8 21h6.4" />
    </template>
    <template v-else>
      <circle cx="12" cy="12" r="8.75" />
      <path d="M8.55 10h.01M15.45 10h.01M8.5 14.05c.9 1.25 2.05 1.85 3.5 1.85s2.6-.6 3.5-1.85" />
    </template>
  </svg>
</template>

<script>
export default {
  name: "ChatComposerIcon",
  props: {
    name: {
      type: String,
      default: "emoji",
      validator: value => ["image", "voice", "emoji"].includes(value)
    }
  }
}
</script>

<style scoped>
.chat-composer-icon{width:20px;height:20px;display:block;fill:none;stroke:currentColor;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round;vector-effect:non-scaling-stroke}
</style>
